<template>
  <div class="flex items-center w-full">
    <div class="w-11  flex flex-col items-center pr-3 pt-1">
      <RydIcon :icon="`history/${categoryIcon}`" />
    </div>
    <div 
      class="pl-3 flex flex-col w-full border-l"
      :class="isUpcoming ? 'border-secondary-btn-bg' : 'border-card-outline'"
    >
      <div
        class="border-b pb-2 w-full"
        :class="isUpcoming ? 'border-secondary-btn-bg' : 'border-card-outline'"
      >
        <p class="font-bold fs-14">
          {{ event.information?.name || t(`history.details.cost.category.${categoryText}`) }}
        </p>
        <div v-if="isWashAndRedeemed" class="text-tertiary-text font-normal fs-12 text-left">
          {{ t('history.wash.used') }} {{ dateNoTime(event.information?.redemptionCodes[0]?.updatedAt) }}
        </div>
      </div>
      <div class="flex items-center  justify-between pt-2 w-full">
        <span class="fs-16 font-bold text-tertiary-text">
          {{ formatDate.weekday }} {{ formatDate.date }} - {{ formatDate.time }}
        </span>
        <span v-if="event.information.totalPrice?.isPriceHidden" class="font-normal"> --.-</span>

        <span v-else class="fs-16 font-bold">
          {{ currencyString(event.information?.totalPrice.amount, event.information?.totalPrice.currency) }}
        </span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import RydIcon from '@/components/RydIcon/RydIcon.vue';

import { dateString, currencyString, dateNoTime } from '@/utils//utils';
import { getCategoryIconUtils, getCategoryTextUtils } from '@/store/history/historyUtils';
import { HistoryCostEvent } from '@/store/history/types';
import { PropType, computed } from 'vue';

const props = defineProps({
  event: {
    type: Object as PropType<HistoryCostEvent>,
    required: true
  },
  isUpcoming: {
    type: Boolean,
    required: true
  }
});

const categoryIcon = computed(() =>
  getCategoryIconUtils(props.event.information.category));
const categoryText = computed(() =>
  getCategoryTextUtils(props.event.information.category));
const formatDate = computed(() => {
  const startDate = new Date(props.event.sampleTime);
  return dateString(startDate);
});
const isWashAndRedeemed = computed(() => {
  return props.event.information.category === 'CAR_WASH'
    && props.event.information?.redemptionCodes
    && props.event.information?.redemptionCodes[0]?.isRedeemed;
});
</script>